function InfoModal({isActive, toggle}) {
  return (
    <div id="info-modal" className={`modal ${isActive && "is-active"}`}>
    <div className="modal-background"></div>
    <div className="modal-card">
      <header className="modal-card-head">
        <p className="modal-card-title">FAQ</p>
      </header>
      <section className="modal-card-body">
        <div ><strong>When will I get my tokens?</strong></div>
        <p>They will show up in your wallet within several minutes in most cases. During extra peak period, it could take longer.</p>

        <div ><strong>What happens if I send the wrong amount?</strong></div>
        <p>A refund will arrive in your wallet for the amount with the transaction fee subtracted.</p>

        <div><strong>How many times can I send to the same purchase instruction?</strong></div>
        <p>Only send once. Sending more will initiate a refund. If you want to get more, click "Get another one".</p>

        <div><strong>Why isn't my refund the full amount?</strong></div>
        <p>We have to subtract the transaction fee (approximately 0.16 ADA - 0.18 ADA) when we send you the refund. This is part of how the network works.</p>

        <div><strong>What wallet can I use?</strong></div>
        <p>Only use Yoroi, Daedalus, or Adalite. DO NOT use a wallet from an exchange.</p>

        <div><strong>What happens if I use a wallet from an exchange?</strong></div>
        <p>Your tokens will be lost forever! A refund cannot be issued in this case.</p>
      </section>
      <footer className="modal-card-foot">
        <button className="button close" onClick={toggle}>Close</button>
      </footer>
    </div>
  </div>
  );
}

export default InfoModal;